<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
            <b-button
              variant="primary"
              v-if="IsAdmin()"
              v-b-modal.modal-add-department
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add New Department
            </b-button>
            <b-modal
              id="modal-add-department"
              ok-only
              ok-title="Add"
              centered
              size="lg"
              title="Add Department"
              :hide-footer="true"
              ref="addDepartment"
            >
              <AddDepartment @DepartmentAdded="closeAddModal" />
            </b-modal>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" sm="8" class="my-1"> </b-col>

          <b-col
            cols="12"
            class="d-flex justify-content-end mb-2"
            style="position: relative; z-index: 1"
          >
            <b-button variant="outline-danger" size="sm" @click="clearFilters">
              Clear Filters
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="filteredDepartments"
              :fields="department_fields"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template #head(departmentName)="scope">
                <div class="d-flex flex-column">
                  <span
                    @click="toggleSort('departmentName')"
                    style="cursor: pointer"
                    >Department Name</span
                  >
                  <b-form-input
                    v-model="filters.departmentName"
                    placeholder="Filter by Department Name"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    :disabled="!IsAdmin()"
                    v-b-modal.modal-edit-department
                    @click="editDepartment(data.item)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    :disabled="!IsAdmin()"
                    @click="removeDepartment(data.item.departmentId)"
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    :disabled="!IsAdmin()"
                    @click="AddDesignation(data.item.departmentId)"
                  >
                    <feather-icon icon="PlusIcon" />
                    <span class="align-middle ml-50">Designation</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner
                variant="success"
                label="Spinning"
                block
                v-if="loading"
                style="width: 3rem; height: 3rem"
              ></b-spinner>
            </div>
            <b-modal
              id="modal-edit-department"
              ok-only
              ok-title="Edit"
              centered
              size="lg"
              title="Edit Department"
              :hide-footer="true"
              ref="editDepartment"
            >
              <EditDepartment
                :department="currentDepartment"
                @DepartmentUpdated="closeEditModal"
              />
            </b-modal>
          </b-col>

          <b-modal
            id="modal-add-designation"
            ok-only
            ok-title="Add"
            centered
            size="lg"
            title="Add Designation"
            :hide-footer="true"
            ref="addDesignation"
          >
            <!-- <AddDesignation @DesignationAdded="closeAddModal" /> -->

            <b-row>
              <validation-observer
                ref="AddDesignationForm"
                v-slot="{ invalid, errors }"
              >
                <b-form @submit.prevent="formSubmitted">
                  <b-row class="ml-1">
                    <b-col cols="12">
                      <!-- <b-col sm="12">
                <b-form-group label="Department" label-for="departmentName">
                  <b-form-select
                    v-model="selectedDepartment"
                    :options="departmentOptions"
                  />
                </b-form-group>
              </b-col> -->
                      <b-row>
                        <b-col md="6">
                          <b-form-group
                            label="Working Hours"
                            label-for="workingHours"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Working Hours"
                              rules="required|max_working_hours"
                            >
                              <b-form-input
                                v-model="workingHours"
                                name="workingHours"
                                placeholder="Working Hours"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group
                            label="Designation Name"
                            label-for="designationName"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Designation Name"
                              rules="required"
                            >
                              <b-form-input
                                v-model="designationName"
                                name="designationName"
                                placeholder="Designation Name"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group
                            label="Minimum Salary"
                            label-for="minimumSalary"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="minimumSalary"
                              :rules="[
                                {
                                  required: true,
                                  message: 'Minimum Salary is required',
                                },
                                {
                                  numeric_decimal: true,
                                  message: 'Please enter a valid number',
                                },
                                {
                                  validate: (value) =>
                                    value >= 0 || 'Salary cannot be negative',
                                  message: 'Salary cannot be negative',
                                },
                              ]"
                            >
                              <b-form-input
                                v-model.number="minimumSalary"
                                @input="checkNegative"
                                @blur="validate"
                                type="number"
                                name="minimumSalary"
                                placeholder="Minimum Salary"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>

                        <b-col md="6">
                          <b-form-group
                            label="Maximum Salary"
                            label-for="maximumSalary"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="maximumSalary"
                              :rules="[
                                {
                                  required: true,
                                  message: 'Minimum Salary is required',
                                },
                                {
                                  numeric_decimal: true,
                                  message: 'Please enter a valid number',
                                },
                                {
                                  validate: (value) =>
                                    value >= 0 || 'Salary cannot be negative',
                                  message: 'Salary cannot be negative',
                                },
                              ]"
                            >
                              <b-form-input
                                v-model.number="maximumSalary"
                                @input="checkNegative"
                                @blur="validate"
                                type="number"
                                name="maximumSalary"
                                placeholder="Maximum Salary"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-col
                        md="12"
                        class="d-flex justify-content-between mb-1"
                      >
                        <b-button
                          type="submit"
                          variant="primary"
                          :disabled="invalid"
                        >
                          Save
                        </b-button>
                      </b-col>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-row>
            <b-row> </b-row>
            <b-row>
              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="perPage1"
                  :current-page="currentPage1"
                  :items="designationList"
                  :fields="designation_fields"
                  :filter-included-fields="filterOn"
                >
                </b-table>
                <b-col cols="12">
                  <b-pagination
                    v-model="currentPage1"
                    :total-rows="totalRows1"
                    :per-page="perPage1"
                    align="center"
                    size="sm"
                    class="my-0"
                  />
                  <b-form-group>
                    Showing
                    {{ totalRows1 > 0 ? perPage1 * (currentPage1 - 1) + 1 : 0 }}
                    to
                    {{
                      totalRows1 > 0
                        ? Math.min(perPage1 * currentPage1, totalRows1)
                        : 0
                    }}
                    of
                    {{ totalRows1 > 0 ? totalRows1 : 0 }}
                    entries
                  </b-form-group>
                </b-col>

                <div class="d-flex justify-content-center mb-1">
                  <b-spinner
                    variant="success"
                    label="Spinning"
                    block
                    v-if="loading"
                    style="width: 3rem; height: 3rem"
                  ></b-spinner>
                </div>
              </b-col>
            </b-row>
          </b-modal>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
            <b-form-group>
              Showing
              {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
              to
              {{
                totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0
              }}
              of
              {{ totalRows > 0 ? totalRows : 0 }}
              entries
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BButton,
  BInputGroupAppend,
  BModal,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import AddDepartment from "./AddDepartment.vue";
import EditDepartment from "./EditDepartment.vue";
import AddDesignation from "./AddDesignation.vue";
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "@validations";
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";

extend("max_working_hours", {
  validate: (value) => {
    const isNumber = /^[0-9]*\.?[0-9]+$/.test(value);
    if (!isNumber) return false;

    const hours = parseFloat(value);
    return hours >= 0 && hours <= 24;
  },
  message: "Working hours must be a number between 0 and 24.",
});
extend("minValue", {
  validate: (value) => {
    if (this == null) {
      return true;
    }
    if (this.maximumSalary < this.minimumSalary) {
      return false;
    }
  },
  message: "Maximum salary must be greater than minimum salary!",
});

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BForm,
    BModal,
    BSpinner,
    BDropdown,
    BDropdownItem,
    AddDepartment,
    EditDepartment,
    AddDesignation,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      currentDepartment: {},
      perPage: 5,
      perPage1: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      totalRows1: 1,
      currentPage: 1,
      currentPage1: 1,
      filter: null,
      department_Id: null,
      //selectedDepartment: null,
      workingHours: null,
      designationName: "",
      minimumSalary: "",
      maximumSalary: "",
      designationList: [],
      filters: {
        departmentName: "",
      },
      filterOn: ["departmentName"],
      department_fields: [
        { key: "departmentName", label: "Department Name", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      designation_fields: [
        { key: "departmentName", label: "Department Name", sortable: true },
        { key: "designationName", label: "Designation Name", sortable: true },
        { key: "workingHours", label: "Working Hours", sortable: true },
      ],
    };
  },
  computed: {
    ...mapGetters("departmentModule", {
      departments: "departments",
      loading: "loading",
    }),

    ...mapGetters("designationModule", {
      designations: "designations",
      loading: "loading",
    }),

    filteredDepartments() {
      const filtered = this.departments.filter((department) => {
    return (
      !this.filters.departmentName ||
      department.departmentName
        .toLowerCase()
        .includes(this.filters.departmentName.toLowerCase())
    );
  });

 
  return filtered.sort((a, b) => {
    const nameA = a.departmentName?.toLowerCase() || '';
    const nameB = b.departmentName?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });
    },
  },
  methods: {
    ...mapActions("departmentModule", [
      "getDepartmentListAction",
      "removeDepartmentAction",
    ]),
    ...mapActions("designationModule", [
      "getDesignationListAction",
      "addDesignationAction",
    ]),

    editDepartment(department) {
      this.currentDepartment = department;
    },
    addDepartment(department) {
      this.currentDepartment = department;
    },
    removeDepartment(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeDepartmentAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Department has been deleted",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getDepartmentListAction().then(() => {
                this.totalRows = this.departments.length;
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error!",
                text: error.response.data.message,
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getDepartmentListAction().then(() => {
                this.totalRows = this.departments.length;
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Department not deleted",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    AddDesignation(id) {
      this.department_Id = id;
      this.designationList = this.designations.filter(
        (x) => x.departmentId == id
      );
      this.totalRows1 = this.designationList.length;
      this.$refs.addDesignation.show();
    },

    checkNegative() {
      if (this.minimumSalary < 0) {
        this.minimumSalary = 0; // Set to 0 or show a warning if needed
      }

      if (this.maximumSalary < 0) {
        this.maximumSalary = 0; // Set to 0 or show a warning if needed
      }
    },

    errorRequired() {
      this.$swal({
        title: "Error!",
        text: "Please fill in minimum and maximum salary!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorSalary() {
      this.$swal({
        title: "Error!",
        text: " Maximum salary must be greater than minimum salary!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    formSubmitted() {
      const isValid = this.$refs.AddDesignationForm.validate();

      if (isValid) {
        this.loading = true;

        if (this.maximumSalary == "" || this.minimumSalary == "") {
          this.errorRequired();
          return;
        }

        if (this.maximumSalary < this.minimumSalary) {
          this.errorSalary();
          return;
        }

        let designationData = {
          departmentId: this.department_Id,
          workingHours: this.workingHours,
          designationName: this.designationName,
          minimumSalary: this.minimumSalary,
          maximumSalary: this.maximumSalary,
        };

        let loader = this.$swal({
          title: "Processing...",
          text: "Please wait while the Designation is being added",
          onOpen: () => {
            this.$swal.showLoading();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          buttonsStyling: false,
          showConfirmButton: false,
        });

        this.addDesignationAction(designationData)
          .then(() => {
            
            loader.close();
            this.success();
            this.$bvModal.hide("modal-id");
            this.loading = false;


          this.workingHours = null,
          this.designationName='';
          this.minimumSalary = "";
         this.maximumSalary= "";

            this.getDesignationListAction().then(() => {
              this.designationList = this.designations.filter(
                (x) => x.departmentId == this.department_Id
              );
              this.totalRows1 = this.designationList.length;
            });
          })
          .catch((error) => {
            loader.close();
            this.error(error.response.data);
            this.loading = false;
            this.getDesignationListAction().then(() => {
              this.designationList = this.designations.filter(
                (x) => x.departmentId == this.department_Id
              );
              this.totalRows1 = this.designationList.length;
            });
          });
      }
    },

    success() {
      this.$swal({
        title: "Designation added!",
        text: "You have successfully added the Designation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$emit("DesignationAdded");
        }
        workingHours = null,
            designationName = "",
            minimumSalary = "",
            maximumSalary = "";
      });
      
    },
    error(data) {
      this.$swal("Error!", this.getErrorString(data) || "Failed!", "error");
    },

    getErrorString(data) {
      let msg = "";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop]
            .toString()
            .replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },

    async closeAddModal() {
      this.$refs.addDepartment.hide();
      await this.getDepartmentListAction().then(() => {
        this.totalRows = this.departments.length;
      });
      this.totalRows = this.departments.length;
    },
    async closeEditModal() {
      this.$refs.editDepartment.hide();
      await this.getDepartmentListAction().then(() => {
        this.totalRows = this.departments.length;
      });
      this.totalRows = this.departments.length;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    applyFilters() {
      this.currentPage = 1; // Reset to the first page when filters are applied
    },
    clearFilters() {
      // Reset all filter values to their default state
      this.filters = {
        departmentName: "",
      };

      // Reset the current page and filtered items
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.getDepartmentListAction().then(() => {
      this.totalRows = this.departments.length;
    });

    await this.getDesignationListAction().then(() => {
      this.designationList = this.designations;
      this.totalRows1 = this.designationList.length;
    });
  },
  setup() {
    return {
      IsAdmin,
    };
  },
};
</script>
